// extracted by mini-css-extract-plugin
export default {"yj-font-style":"yj-font-style--SFjKM","NotFoundPage":"NotFoundPage--Seqqg"};